// src/pages/DashboardHome.js
import React from 'react';
import TrialExpiredOverlay from '../components/TrialExpiredOverlay';
import './DashboardHome.css';

function DashboardHome() {
  return (
    <div className="dashboard-home" style={{ position: 'relative', minHeight: '500px' }}>
      <TrialExpiredOverlay section="dashboard" />
      <h1>Dashboard</h1>
      <p>Welcome to your dashboard!</p>

      <div className="dashboard-stats">
        <div className="stat-card">
          <h3>Documents</h3>
          <p className="stat-number">8</p>
        </div>
        <div className="stat-card">
          <h3>Catégories</h3>
          <p className="stat-number">5</p>
        </div>
        <div className="stat-card">
          <h3>Activités récentes</h3>
          <p className="stat-number">12</p>
        </div>
      </div>
      
      <div className="recent-documents">
        <h2>Documents récents</h2>
        <ul>
          <li>Document technique</li>
          <li>Rapport financier 2024</li>
          <li>Guide utilisateur v2</li>
        </ul>
      </div>
    </div>
  );
}

export default DashboardHome;